// extracted by mini-css-extract-plugin
module.exports = {"selection_title":"BigRadioGroup_selection_title__23-EL","selection_footer":"BigRadioGroup_selection_footer__3WvSZ"};